import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom"

Sentry.init({
  dsn: "https://d5acc512772993d839bdbfc1c16b8f84@o4508716617826304.ingest.de.sentry.io/4508767733481552",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 5 / 100,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    "localhost",
    /^\//,
    /^https:\/\/app\.traceforgood\.com\/api/,
    /^https:\/\/app\.staging\.traceforgood\.com\/api/,
  ],

  // Capture Replay
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 5 / 100, // This sets the sample rate. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 100 / 100, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
export const sentryCreateBrowserRouter: typeof createBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
